import { render, staticRenderFns } from "./educationExperienceDetail.vue?vue&type=template&id=80789ab0&scoped=true&"
import script from "./educationExperienceDetail.vue?vue&type=script&lang=js&"
export * from "./educationExperienceDetail.vue?vue&type=script&lang=js&"
import style0 from "./educationExperienceDetail.vue?vue&type=style&index=0&id=80789ab0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80789ab0",
  null
  
)

export default component.exports